export default {"src":"/_next/static/media/Lemonade.3e323736.svg","height":45,"width":197,"blurWidth":0,"blurHeight":0};